import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { createWarning } from '@core/helpers/create-validator.helper';
import { isSameDay, parseISO } from 'date-fns';

@Injectable()
export class ContribBiennaleWarningsService {
    constructor(private readonly store: Store<Revisione53State>) {}

    my_ContribBiennale = createWarning(this.store, (myVerbale) => {
        const my_continuitaNelleRevisioni = myVerbale.my_continuitaNelleRevisioni;

        if (my_continuitaNelleRevisioni !== 'S') {
            return "Attenzione, verificare e allegare al verbale la situazione contributiva come da sito MiSE. Nell'impossibilità di recupero richiedere documenti attestanti versamenti effettuati o, in caso di mancata dimostrazione, dichiarazione sostitutiva di atto notorio sottoscritta dal legale rappresentante.";
        } else {
            return null;
        }
    });

    descriptionDomanda49 = createWarning(this.store, (myVerbale) => {
        const my_DataScadCalcPenal = myVerbale.my_SezioneI__Rilevazione.my_ContributoBiennale.my_DataScadCalcPenal;
        const targetDate = new Date(2079, 0, 1);
        if (isSameDay(parseISO(my_DataScadCalcPenal), targetDate)) {
            return 'La scheda è stata compilata in assenza della emanazione del decreto che stabilisce gli importi del contributo di revisione per il biennio di riferimento. Il contributo di revisione dovuto, pertanto, dovrà essere verificato.';
        } else {
            return null;
        }
    });
}
